import { Fragment } from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import SelectCustomStyles from "../../../../../utils/styles/reactSelect";
import countries from "../../../../../data/countries";
import { useTranslation } from "react-i18next";

function AddressTab({ supplierData, onChangeInput }) {
  const { t } = useTranslation();
  return (
    <Fragment>
      <FormGroup>
        <Label>{t("settings.addressLine1")}</Label>
        <Input
          name="address_line_1"
          value={supplierData.address_line_1}
          onChange={(e) => onChangeInput(e.target)}
        />
      </FormGroup>

      <FormGroup>
        <Label>{t("settings.addressLine2")}</Label>
        <Input
          name="address_line_2"
          value={supplierData.address_line_2}
          onChange={(e) => onChangeInput(e.target)}
        />
      </FormGroup>

      <Row>
        <Col md="6" className="mb-3">
          <Label>{t("address.city")}</Label>
          <Input
            name="city"
            value={supplierData.city}
            onChange={(e) => onChangeInput(e.target)}
          />
        </Col>
        <Col md="6" className="mb-3">
          <Label>{t("settings.state")}</Label>
          <Input
            name="state"
            value={supplierData.state}
            onChange={(e) => onChangeInput(e.target)}
          />
        </Col>
      </Row>

      <Row>
        <Col md="6" className="mb-3">
          <Label>{t("settings.zipPostal")}</Label>
          <Input
            name="postal_code"
            value={supplierData.postal_code}
            onChange={(e) => onChangeInput(e.target)}
          />
        </Col>
        <Col md="6" className="mb-3">
          <Label>{t("address.country")}</Label>
          <Select
            value={countries.map(c => ({ value: c.slug, label: c.name })).find(o => o.value === supplierData.country) || null}
            onChange={(selected) => onChangeInput({ name: 'country', value: selected ? selected.value : '' })}
            options={countries.map((country) => ({ value: country.slug, label: country.name }))}
            styles={SelectCustomStyles}
          />
        </Col>
      </Row>
    </Fragment>
  );
}

export default AddressTab;
